import { render, staticRenderFns } from "./SignList.vue?vue&type=template&id=c945f170&scoped=true&"
import script from "./SignList.vue?vue&type=script&lang=js&"
export * from "./SignList.vue?vue&type=script&lang=js&"
import style0 from "./SignList.vue?vue&type=style&index=0&id=c945f170&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c945f170",
  null
  
)

export default component.exports